import { render, staticRenderFns } from "./assistHelpRecord.vue?vue&type=template&id=9dd289e8&scoped=true&"
import script from "./assistHelpRecord.vue?vue&type=script&lang=js&"
export * from "./assistHelpRecord.vue?vue&type=script&lang=js&"
import style0 from "./assistHelpRecord.vue?vue&type=style&index=0&id=9dd289e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd289e8",
  null
  
)

export default component.exports